export default [
  {
    path: '/maintenance',
    name: 'maintain',
    component: () => import('@/views/error/Maintain.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/error-404',
    name: 'error-404',
    component: () => import('@/views/error/Error404.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '/holiday',
    name: 'holiday',
    component: () => import('@/views/error/Holiday.vue'),
    meta: {
      layout: 'full',
    },
  },
  {
    path: '*',
    redirect: 'error-404',
  },
]
